import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="max-w-lg mx-auto px-4 sm:px-6 py-16">
        <div className="border rounded-3xl bg-card p-8 text-center" data-testid="payment-cancelled">
          <XCircle className="w-10 h-10 mx-auto text-muted-foreground" />
          <h1 className="mt-4 font-display font-bold text-2xl">Payment cancelled</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            You closed the checkout page. Nothing was charged. You can try again any time.
          </p>
          <Link
            to="/home"
            className="mt-6 inline-block rounded-full px-4 py-2 text-sm border hover:bg-secondary"
            data-testid="cancel-return-home"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
